import React from "react";
import { Link } from "gatsby";
import { Spinner } from "../Global.elements";
import AssetImage from "../AssetImage/AssetImage";

const Inventory = ({ items, cols, mobileCols, minRows, smallerImages, alwaysShowAmount }) => {
  const minItems = cols * minRows;

  const itemContent = (item) => {
    return (
      <>
        <div className="image">
          {item.image &&
            ((typeof item.image === "string" && <img src={item.image} alt={item.title} />) ||
              (typeof item.image === "object" && <AssetImage asset={item.image} alt={item.title} onlyImg={true} />))}
        </div>
        <div className="title">{item.title}</div>
        {item.status && <div className="status">{item.status}</div>}
        <div className="amount">{alwaysShowAmount ? item.amount : item.amount !== 1 ? item.amount : ""}</div>
      </>
    );
  };

  return items ? (
    <div
      className={`inventory grid cols-${cols} cols-m-${mobileCols || cols} ${smallerImages ? "smaller-images" : ""}`}
    >
      {items.map((item, index) => (
        <div
          key={index}
          className={[
            "item-container",
            item.to && "interactive",
            item.action && "interactive",
            item.sparkle && "sparkle",
          ]
            .filter((a) => a)
            .join(" ")}
        >
          {item.to ? (
            <Link
              to={item.to}
              state={item.toState || {}}
              className={["item", item.angled && "angled", item.amount === 0 && "not-owned"].filter((a) => a).join(" ")}
            >
              {itemContent(item)}
            </Link>
          ) : (
            <div
              className={["item", item.angled && "angled", item.amount === 0 && "not-owned"].filter((a) => a).join(" ")}
              onClick={item.action}
            >
              {itemContent(item)}
            </div>
          )}
        </div>
      ))}
      {new Array(Math.max(0, minItems - items.length)).fill(null).map((_, index) => (
        <div key={`empty-${index}`} className="item-container">
          <div className="item"></div>
        </div>
      ))}
    </div>
  ) : (
    <div className="spinner-container">
      <Spinner />
    </div>
  );
};

export default Inventory;
